import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'modal-view-bid-images',
    styleUrls: ['./modal-view-bid-images.component.scss'],
    templateUrl: 'modal-view-bid-images.component.html'
})
export class ModalViewBidImagesComponent {
  
    @Output() save: EventEmitter<NgForm> = new EventEmitter();

    constructor(public activeModal: NgbActiveModal) {
        let me = this;
    }

    ngOnInit() {
        let me = this;
    }

    Save(form, e) {
        this.save.emit(form);
    }
 }